module.exports = __webpack_public_path__ + "static/img/11.48544fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/sp/11.png
// module id = CZ2R
// module chunks = 0